import React, { Component } from 'react';
import { Slide, Fade, Zoom } from '../../src';
import 'react-slideshow-image/dist/styles.css'
import './slider.styles.scss'
import { useHistory } from 'react-router-dom';
import { BrowserRouter as Router, Route, Link, } from "react-router-dom";

// const history = useHistory()
class Slider extends Component {
  constructor() {
    super();
    this.state = {
      // history : useHistory(),
      zoomOutImages: [
        'assets/images/Absa-Digital-Proposition-3.jpg',
        'assets/images/Absa-Digital-Proposition.jpg',
        'assets/images/Absa-Digital-Proposition-2.gif'
      ],
      slideImages: [  
        {
          image: require('../../assets/images/Absa-Digital-Proposition-3.jpg'),
          imageurl: "https://www.absa.co.za/homeloanonline",
        },
        {
          image: require('../../assets/images/Absa-Digital-Proposition.jpg'),
          imageurl: "https://www.absa.co.za/homeloanonline",
        },
        {
          image: require('../../assets/images/Absa-Digital-Proposition-2.gif'),
          imageurl: "https://www.absa.co.za/homeloanonline",
        }
      ],
      fadeImages: [
        'assets/images/Absa-Digital-Proposition-3.jpg',
        'assets/images/Absa-Digital-Proposition.jpg',
        'assets/images/Absa-Digital-Proposition-2.gif'
      ]
    };
  }

  render() {
    const properties = {
      duration: 5000,
      transitionDuration: 500,
      infinite: true,
      indicators: true,
      pauseOnHover: true,
      onChange: (oldIndex, newIndex) => {
        console.log(
          `Slide transition finished from ${oldIndex} to ${newIndex}`
        );
      }
    };

    const fadeProperties = {
      duration: 5000,
      transitionDuration: 500,
      indicators: true,
      infinite: false,
      pauseOnHover: true,
      onChange: (oldIndex, newIndex) => {
        console.log(`Fade transition finished from ${oldIndex} to ${newIndex}`);
      }
    };

    const zoomOutProperties = {
      duration: 5000,
      transitionDuration: 500,
      indicators: true,
      scale: 0.4,
      pauseOnHover: true,
      onChange: (oldIndex, newIndex) => {
        console.log(`zoom transition finished from ${oldIndex} to ${newIndex}`);
      }
    };

    const zoomInProperties = {
      duration: 5000,
      transitionDuration: 500,
      indicators: true,
      scale: 1.4,
      pauseOnHover: true
    };
    const { slideImages, zoomOutImages, fadeImages } = this.state;
    return (
      <div className="slide-outside-container">
        <div className="slide-container">
          <Slide {...properties}>
            { slideImages.map((each, index) => (
              <a target="_blank" href={`${each.imageurl}`} title="">
              <div className="each-slide">
                 <div key={index} style={{ backgroundImage: `url(${each.image})`}}>
                </div>
              </div>
              </a>
            ))}
          </Slide>
        </div>
        <br />
      </div>
    );
  }
}

export default Slider;

